import { useRef } from "react";

export function DatePickerLabel({ value, onChange, label }) {
  const ref = useRef(null);
  return (
    <div className="relative">
      <button
        type="button"
        data-testid="agenda-date-label"
        onClick={() => {
          const el = ref.current;
          if (!el) return;
          if (typeof el.showPicker === "function") el.showPicker();
          else { el.focus(); el.click(); }
        }}
        className="px-3 py-1.5 text-sm font-bold min-w-[200px] text-center capitalize rounded-full border border-transparent hover:border-[color:var(--sp-border)] hover:bg-white transition-colors cursor-pointer"
      >
        {label}
      </button>
      <input
        ref={ref}
        data-testid="agenda-date-input"
        type="date"
        value={value}
        onChange={(e) => e.target.value && onChange(e.target.value)}
        className="absolute inset-0 opacity-0 pointer-events-none"
        tabIndex={-1}
      />
    </div>
  );
}
